import Config from '../config/constants';
import axios, { AxiosResponse } from 'axios';

export interface logoutResponse {
  result: string;
}

export interface logoutParam {
  kakaoToken: string;
}

export interface appleLoginParam {
  email?: string | null;
  identityToken?: string | null;
  credential?: string | null;
}
export const apiRegisterUser = async (params: any): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/auth/user/register`;
  return axios.post(url, params);
};

export const apiLogin = async (params: any): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/auth/user/branchlogin`;
  console.log(url);
  return axios.post(url, params);
};

export const apiLostPassword = async (params: any): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/auth/user/lost_password`;
  console.log(url);
  return axios.post(url, params);
};

export const apiCheckTempPassword = async (
  params: any,
): Promise<AxiosResponse> => {
  const url = `${Config.API_HOST}/api/auth/user/check_temppassword`;
  console.log(url);
  return axios.post(url, params);
};
